import { Grid } from "@mui/material";

import FormikInput from "../../components/Form/FormikInput";
import Form from "../../components/Templates/Form";
import usePushNotificationContainer from "../../containers/PushNotifications/usePushNotificationContainer";
import { useContent } from "../../content/useContent";

const AddPushNotification = () => {
  const { pageLoading, pushNotificationFormik, loading } =
    usePushNotificationContainer();

  const { pages } = useContent();
  const { pushNotifications } = pages;

  return (
    <Form
      title={pushNotifications.pushNotification}
      pageLoading={pageLoading}
      formik={pushNotificationFormik}
      submitLoading={loading}
      width="75%"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikInput
            formik={pushNotificationFormik}
            name="message"
            label={pushNotifications.message}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddPushNotification;
